import { TodoBlock, ActivitiesBlock, AttentionBlock } from "@/components/dashboard/blocks/TaskBlocks";
import { ChatsBlock, NotificationsBlock, QuickSearchBlock } from "@/components/dashboard/blocks/CommsBlocks";
import { StatBlock } from "@/components/dashboard/blocks/StatBlock";
import { OpportunitiesBlock, CampaignsBlock, CollabsBlock } from "@/components/dashboard/blocks/PipelineBlocks";
import { KpisBlock, PrintOrdersBlock, VouchersBlock } from "@/components/dashboard/blocks/OpsBlocks";
import { NoticeboardBlock } from "@/components/dashboard/blocks/NoticeBlock";
import { PacePropertiesBlock } from "@/components/dashboard/blocks/PaceBlock";

export const BLOCK_COMPONENTS = {
  noticeboard: NoticeboardBlock,
  todo: TodoBlock, stat: StatBlock, chats: ChatsBlock, notifications: NotificationsBlock, quick_search: QuickSearchBlock,
  activities: ActivitiesBlock, opportunities: OpportunitiesBlock, campaigns: CampaignsBlock, collaborations: CollabsBlock,
  kpis: KpisBlock, pace: PacePropertiesBlock, print_orders: PrintOrdersBlock, vouchers: VouchersBlock, attention: AttentionBlock,
};

export const BLOCK_PAGE = {
  noticeboard: "noticeboard", opportunities: "opportunities", campaigns: "campaigns", collaborations: "collaborations",
  kpis: "kpis", pace: "stats", print_orders: "print_orders", vouchers: "prize_vouchers", activities: "actions", todo: "todo",
};
